/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1ClassroomdisciplineIdReprocessStudents200,
  PostApiV1ClassroomdisciplineIdReprocessStudents401,
  PostApiV1ClassroomdisciplineIdReprocessStudents404,
  PostApiV1ClassroomdisciplineIdReprocessStudentsMutationRequest,
  PostApiV1ClassroomdisciplineIdReprocessStudentsMutationResponse,
  PostApiV1ClassroomdisciplineIdReprocessStudentsPathParams,
} from "../../types/classPlanningController/PostApiV1ClassroomdisciplineIdReprocessStudents.ts";
import { reprocessStudentsRequestViewModelSchema } from "../reprocessStudentsRequestViewModelSchema.ts";

export const postApiV1ClassroomdisciplineIdReprocessStudentsPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1ClassroomdisciplineIdReprocessStudentsPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1ClassroomdisciplineIdReprocessStudents200Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineIdReprocessStudents200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1ClassroomdisciplineIdReprocessStudents401Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineIdReprocessStudents401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1ClassroomdisciplineIdReprocessStudents404Schema =
  z.any() as unknown as ToZod<PostApiV1ClassroomdisciplineIdReprocessStudents404>;

export const postApiV1ClassroomdisciplineIdReprocessStudentsMutationRequestSchema =
  z.lazy(
    () => reprocessStudentsRequestViewModelSchema,
  ) as unknown as ToZod<PostApiV1ClassroomdisciplineIdReprocessStudentsMutationRequest>;

export const postApiV1ClassroomdisciplineIdReprocessStudentsMutationResponseSchema =
  z.lazy(
    () => postApiV1ClassroomdisciplineIdReprocessStudents200Schema,
  ) as unknown as ToZod<PostApiV1ClassroomdisciplineIdReprocessStudentsMutationResponse>;
